import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiPopover: {
      styleOverrides: {
        paper: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            borderRadius: 2,
            borderStyle: 'solid',
            borderWidth: 0.5,
            borderColor: theme.palette.grey[200],
            boxShadow: '0px 4px 8px rgba(52, 58, 64, 0.1)',
          }),
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: ({ theme: { unstable_sx: sx } }) => sx({ p: 1 }),
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) =>
          sx({
            borderRadius: 1.5,
            py: 0.75,
            px: 1,
          }),
      },
    },
  },
});

export default theme.components;
